'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign2 = require('lodash/fp/assign');

var _assign3 = _interopRequireDefault(_assign2);

var _setWith2 = require('lodash/fp/setWith');

var _setWith3 = _interopRequireDefault(_setWith2);

var _dropRight2 = require('lodash/dropRight');

var _dropRight3 = _interopRequireDefault(_dropRight2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = dataReducer;

var _constants = require('../constants');

var _query = require('../utils/query');

var _reducers = require('../utils/reducers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_DATA = _constants.actionTypes.CLEAR_DATA,
    GET_SUCCESS = _constants.actionTypes.GET_SUCCESS,
    LISTENER_RESPONSE = _constants.actionTypes.LISTENER_RESPONSE,
    LISTENER_ERROR = _constants.actionTypes.LISTENER_ERROR,
    DELETE_SUCCESS = _constants.actionTypes.DELETE_SUCCESS,
    DOCUMENT_ADDED = _constants.actionTypes.DOCUMENT_ADDED,
    DOCUMENT_MODIFIED = _constants.actionTypes.DOCUMENT_MODIFIED,
    DOCUMENT_REMOVED = _constants.actionTypes.DOCUMENT_REMOVED;
function dataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case GET_SUCCESS:
    case LISTENER_RESPONSE:
      var meta = action.meta,
          payload = action.payload;

      if (!payload || payload.data === undefined) {
        return state;
      }
      var queryName = (0, _query.getQueryName)(meta, { onlySubcollections: true });

      var previousData = (0, _get3.default)(state, meta.storeAs || queryName);
      if (meta.subcollections) {
        var setPath = queryName.split('/').length % 2 ? (0, _query.getQueryName)(meta) : (0, _dropRight3.default)((0, _reducers.pathToArr)(queryName)).join('/');

        return (0, _setWith3.default)(Object, setPath, payload.data, state);
      }

      if (!previousData || meta.subcollections) {
        return (0, _setWith3.default)(Object, meta.storeAs || queryName, payload.data, state);
      }

      var mergedData = (0, _assign3.default)(previousData, payload.data);

      return (0, _setWith3.default)(Object, meta.storeAs || queryName, mergedData, state);
    case DOCUMENT_MODIFIED:
    case DOCUMENT_ADDED:
      return (0, _setWith3.default)(Object, (0, _query.getQueryName)(action.meta, { onlySubcollections: true }), action.payload.data, state);
    case DOCUMENT_REMOVED:
    case DELETE_SUCCESS:
      var removePath = (0, _query.getQueryName)(action.meta, {
        onlySubcollections: true
      });
      var id = (0, _last3.default)((0, _reducers.pathToArr)((0, _query.getQueryName)(action.meta)));
      var cleanedState = (0, _setWith3.default)(Object, removePath + '.' + id, null, state);
      if (action.preserve && action.preserve.data) {
        return (0, _reducers.preserveValuesFromState)(state, action.preserve.data, cleanedState);
      }
      return cleanedState;
    case CLEAR_DATA:
      if (action.preserve && action.preserve.data) {
        return (0, _reducers.preserveValuesFromState)(state, action.preserve.data, {});
      }
      return {};
    case LISTENER_ERROR:
      var nextState = (0, _setWith3.default)(Object, (0, _query.getQueryName)(action.meta, { onlySubcollections: true }), null, state);
      if (action.preserve && action.preserve.data) {
        return (0, _reducers.preserveValuesFromState)(state, action.preserve.data, nextState);
      }
      var existingState = (0, _get3.default)(state, (0, _query.getQueryName)(action.meta, { onlySubcollections: true }));

      if (existingState) {
        return state;
      }
      return nextState;
    default:
      return state;
  }
}